import useBrowserStorage from "../../internal/browserStorage/useBrowserStorage";
import sessionStorage from "../../internal/sessionStorage/sessionStorage";
import useDataConfig from "../useDataConfig";
/**
 * @see https://sail.stripe.me/data/api/useSessionStorage/
 */ export default function useSessionStorage(/* Key of the sessionStorage to interact with */ key) {
    const dataConfig = useDataConfig();
    return useBrowserStorage(dataConfig.browserStorage, sessionStorage, key);
}

//# sourceMappingURL=useSessionStorage.js.map